// @flow
/*
 *  Copyright 2017 Adobe Systems Incorporated. All rights reserved.
 *  This file is licensed to you under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License. You may obtain a copy
 *  of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software distributed under
 *  the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 *  OF ANY KIND, either express or implied. See the License for the specific language
 *  governing permissions and limitations under the License.
 *
 */

import AppsUtil from '../../utils/AppsUtil';
import CSSUtil from '../../utils/CSSUtil';
import React, {Component} from 'react';
import GetFirstAppPage from './GetFirstAppPage/GetFirstAppPage';
import CategoryPage from './CategoryPage/CategoryPage';

type Props = {
	routeParams: Object,
	history: Object,
	routeSchema: Object,
	intl: Object,
	environment: string,
	imsData: Object
};
 
export default class AppPickerMain extends Component<Props> {
	componentDidMount() {
		CSSUtil.addClass(document.getElementsByClassName('footer-container')[0], 'hideFooterOnNewAppPicker');
		CSSUtil.addClass(document.getElementsByClassName('utility-nav-wrapper')[0], 'disableUtilNavIconAppPicker');
		CSSUtil.addClass(document.getElementsByClassName('app-container')[0],'ipad-ccpp-app-picker');
	}

	componentWillUnmount() {
		CSSUtil.removeClass(document.getElementsByClassName('footer-container')[0], 'hideFooterOnNewAppPicker');
		CSSUtil.removeClass(document.getElementsByClassName('utility-nav-wrapper')[0], 'disableUtilNavIconAppPicker');
		CSSUtil.removeClass(document.getElementsByClassName('app-container')[0],'ipad-ccpp-app-picker');
	}

	// Get the app variant that will
	// be offered on this platform
	getPlatformAppInfo(app: string) {
		const appLineage = AppsUtil.getAppLineageFromSapCode(app);
		if (!appLineage) {
			return {sapCode: app};
		}
		if (AppsUtil.isMobileOrTab()) {
			const mobileAppIndex = AppsUtil.appLineageMap[appLineage].platformTypeList.indexOf('mobile');
			if (mobileAppIndex !== -1) {
				return {sapCode: AppsUtil.appLineageMap[appLineage].platformAppList[mobileAppIndex]};
			}
			const desktopAppIndex = AppsUtil.appLineageMap[appLineage].platformTypeList.indexOf('desktop');
			if (desktopAppIndex !== -1) {
				return {sapCode: AppsUtil.appLineageMap[appLineage].platformAppList[desktopAppIndex]};
			}
		}
		else {
			const desktopAppIndex = AppsUtil.appLineageMap[appLineage].platformTypeList.indexOf('desktop');
			if (desktopAppIndex !== -1) {
				return {sapCode: AppsUtil.appLineageMap[appLineage].platformAppList[desktopAppIndex]};
			}
			const mobileAppIndex = AppsUtil.appLineageMap[appLineage].platformTypeList.indexOf('mobile');
			if (mobileAppIndex !== -1) {
				return {sapCode: AppsUtil.appLineageMap[appLineage].platformAppList[mobileAppIndex]};
			}
		}
	}

	getAppPlatform(appConfig: Object) {
		if (appConfig.type.toLowerCase().includes('desktop')) {
			return 'desktop';
		}
		if (appConfig.type.toLowerCase().includes('mobile')) {
			return 'mobile';
		}
	}

	// Get button that is to be displayed
	// on the app tile basis app variant
	// being downloaded and platform.
	getAppBtnType(app: string) {
		const appLineage = AppsUtil.getAppLineageFromSapCode(app);
		const platform = AppsUtil.isMobileOrTab() ? 'mobile' : 'desktop';
		if (!appLineage) {
			// if app lineage not available
			// give desktop app variant by default
			const appVariant = 'desktop';
			return platform === appVariant ? 'download' : 'send-link';
		}
		if (AppsUtil.appLineageMap[appLineage].platformTypeList.indexOf(platform) === -1) {
			return 'sendlink';
		}
		return platform === 'mobile' ? 'get' : 'download';
	}

	renderAppPickerPhotoPlan() {
		if (this.props.routeParams.pdpTab === 'installation' && !AppsUtil.isMobileOrTab()) {
			// render desktop installation component.
		}
		if (this.props.routeParams.pdpTab === 'categories') {
			return <CategoryPage {...this.props} getPlatformAppInfo={this.getPlatformAppInfo} getAppBtnType={this.getAppBtnType} getAppPlatform={this.getAppPlatform} />;
		}
		return <GetFirstAppPage {...this.props} getPlatformAppInfo={this.getPlatformAppInfo} getAppBtnType={this.getAppBtnType} getAppPlatform={this.getAppPlatform} />;
	}

	render() {
		return (this.renderAppPickerPhotoPlan());
	}
}
